import Vue from "vue";
import VueRouter from "vue-router";
import { getToken, setToken } from "../utils/tokenManager";
import store from "../store/";

Vue.use(VueRouter);

export const constantRoutes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login"),
  },
  {
    path: "/noLayout",
    name: "noLayout",
    component: () => import("./noLayout"),
  },
];

const createRouter = (routes) =>
  new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
  });

const router = createRouter(constantRoutes);

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

router.beforeEach((to, from, next) => {
  try {
    // console.log(to)
    const isSwitch = new URL(window.location).searchParams.get("isSwitch");
    const isLogOut = new URL(window.location).searchParams.get("isLogOut");
    if (isSwitch === "YES") {
      const token = new URL(window.location).searchParams.get("token");
      setToken(token);
    }
    if (isLogOut === "YES") {
      window.sessionStorage.clear();
    }

    if (!getToken()) {
      if (to.path === "/login") next();
      else next({ path: "/login" });
    } else {
      if (!store.state.permission.isHasRoute) {
        store.dispatch("permission/FETCH_PERMISSION").then(() => {
          if (to.fullPath === "/app" || to.fullPath === "/app/") {
            next({ path: store.getters["permission/GET_FIRSTROUTEPATH"] });
          } else {
            const hasPermission = store.getters["permission/HAS_PERMISSION"](
              to.path
            );
            if (hasPermission) next({ path: to.fullPath });
            else next({ path: store.getters["permission/GET_FIRSTROUTEPATH"] });
          }
        });
      } else {
        if (to.path !== "/login") {
          next();
        } else {
          next(from.fullPath);
        }
      }
    }
  } catch (error) {
    console.error(error);
  }
});

export default router;
